// extracted by mini-css-extract-plugin
export default {"icon-container":"select-menu-message_icon-container__jLrIT"};